export default "__VITE_ASSET__BWEZ906q__"